import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

// [VinUni] Module 8 - Quản lý văn bản

export const getAllDocument = () => async (dispatch) => {
  const api = API_URLS.DOCUMENT.getAllDocument();
  dispatch({
    type: TYPE.DOCUMENT.GET_ALL_DOCUMENT_LOADING,
    meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.DOCUMENT.GET_ALL_DOCUMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.DOCUMENT.GET_ALL_DOCUMENT_FAILURE,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy danh sách văn bản thất bại!" }));
  }
};

export const getDocumentByDepartmentId = (departmentId) => async (dispatch) => {
  const api = API_URLS.DOCUMENT.getDocumentByDepartmentId(departmentId);
  dispatch({
    type: TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_LOADING,
    meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.DOCUMENT.GET_DOCUMENT_BY_DEPARTMENT_FAILURE,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Lấy danh sách văn bản theo đơn vị thất bại!" }));
  }
};

export const insertDocument = (payload, cleanUp) => async (dispatch) => {
  const api = API_URLS.DOCUMENT.insertDocument();
  dispatch({
    type: TYPE.DOCUMENT.INSERT_DOCUMENT_LOADING,
    meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.DOCUMENT.INSERT_DOCUMENT_SUCCESS,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_SUCCESS] },
    });
    if (cleanUp) cleanUp();
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.DOCUMENT.INSERT_DOCUMENT_FAILURE,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Thêm văn bản thất bại!" }));
    return { success: false };
  }
};

export const updateDocument = (id, payload, cleanUp) => async (dispatch) => {
  const api = API_URLS.DOCUMENT.updateDocument(id);
  dispatch({
    type: TYPE.DOCUMENT.UPDATE_DOCUMENT_LOADING,
    meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.DOCUMENT.UPDATE_DOCUMENT_SUCCESS,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_SUCCESS] },
    });
    if (cleanUp) cleanUp();
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.DOCUMENT.UPDATE_DOCUMENT_FAILURE,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Cập nhật văn bản thất bại!" }));
    return { success: false };
  }
};

export const deleteDocument = (id) => async (dispatch) => {
  const api = API_URLS.DOCUMENT.deleteDocument(id);
  dispatch({
    type: TYPE.DOCUMENT.DELETE_DOCUMENT_LOADING,
    meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.DOCUMENT.DELETE_DOCUMENT_SUCCESS,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_SUCCESS] },
    });
    dispatch(notification({ type: "success", message: "Xoá văn bản thành công!" }));
    dispatch(getAllDocument());
  } else {
    dispatch({
      type: TYPE.DOCUMENT.DELETE_DOCUMENT_FAILURE,
      meta: { prefix: [PREFIX.DOCUMENT, PREFIX.API_FAILURE] },
    });
    dispatch(notification({ type: "error", message: "Xoá văn bản thất bại!" }));
  }
};
